import { isContractPartyAdmin, isHubAdmin } from './networkMode.js';

export const PARTY_LINKED_ROLES = ['Agent', 'Contract Party Admin'];

const COMPANY_USER_MANAGER_ROLES = [
  'Admin',
  'Accountant',
  'Agent',
  'Driver',
  'Contract Party Admin',
  'Hub Admin',
];

/** Add / edit user role dropdown order. Other roles follow these. */
const USER_ROLE_ORDER = [
  'Admin',
  'Accountant',
  'Hub Admin',
  'Agent',
  'Contract Party Admin',
  'Driver',
];

function sortRolesForUserForm(roles) {
  if (!Array.isArray(roles)) return [];
  const rank = (name) => {
    const index = USER_ROLE_ORDER.indexOf(name);
    return index === -1 ? USER_ROLE_ORDER.length : index;
  };
  return [...roles].sort((a, b) => {
    const diff = rank(a.role_name) - rank(b.role_name);
    if (diff !== 0) return diff;
    return String(a.role_name || '').localeCompare(String(b.role_name || ''));
  });
}

/** Roles the current user may assign when creating or editing users. */
export function filterCreatableRoles(allRoles, currentUser) {
  if (!Array.isArray(allRoles) || !currentUser) {
    return sortRolesForUserForm(allRoles || []);
  }

  if (isContractPartyAdmin(currentUser) || isHubAdmin(currentUser)) {
    return sortRolesForUserForm(allRoles.filter((role) => role.role_name === 'Agent'));
  }

  if (currentUser.role === 'System Admin') {
    return sortRolesForUserForm(allRoles);
  }

  if (currentUser.role === 'Admin' || currentUser.role === 'Accountant') {
    const isInternal = currentUser.network_mode !== 'EXTERNAL';
    return sortRolesForUserForm(allRoles.filter((role) => {
      if (!COMPANY_USER_MANAGER_ROLES.includes(role.role_name)) {
        return false;
      }
      // Hub Admin only for internal network companies
      if (role.role_name === 'Hub Admin' && !isInternal) {
        return false;
      }
      return true;
    }));
  }

  return sortRolesForUserForm(allRoles);
}

export function showUserPartyLabel(roleName) {
  return PARTY_LINKED_ROLES.includes(roleName);
}

export function getUserPartyLabel(user) {
  if (!user || !showUserPartyLabel(user.role_name)) {
    return null;
  }
  if (user.role_name === 'Agent') {
    return user.party_name || 'Own Company';
  }
  return user.party_name || '—';
}

/** Keep the user's existing role visible on edit even if not assignable. */
export function ensureRoleInList(roles, roleId, allRoles) {
  if (roleId == null) {
    return roles;
  }
  const currentRole = allRoles.find((role) => role.id === roleId);
  if (currentRole && !roles.some((role) => role.id === currentRole.id)) {
    return sortRolesForUserForm([currentRole, ...roles]);
  }
  return sortRolesForUserForm(roles);
}
